import * as React from "react";
import {Checkbox, Icon, Input, Modal, TextArea} from "semantic-ui-react";
import {formatDate} from "../../../components/Table/dataHandler/Utils";
import Button from "../../../components/Button";
import {FaqDto} from "../../../services/Client";

interface IFaqCreationDialogProps {
    editItem?: FaqDto;
    /** Callback when the user exits the dialog. */
    onExitDialog: (faqDto?: FaqDto) => any;
    t: reactI18Next.TranslationFunction;
}

interface IFaqCreationDialogState {
    question: string;
    answer: string;
    active: boolean;
}

class FaqCreationDialog extends React.Component<IFaqCreationDialogProps, IFaqCreationDialogState> {
    QUESTION_SIZE = 50;
    ANSWER_SIZE = 2048;

    constructor(props: IFaqCreationDialogProps) {
        super(props);

        this.state = {
            question: "",
            answer: "",
            active: true
        };
    }

    componentDidMount() {
        const {editItem} = this.props;
        if (editItem) {
            this.setState({
                question: editItem.question,
                answer: editItem.answer,
                active: editItem.active === undefined ? true : editItem.active,
            });
        }
    }

    onClickCreate = (): void => {
        if (this.isFormValid()) {
            const faqDto: FaqDto = {
                question: this.state.question.trim(),
                answer: this.state.answer.trim(),
                active: this.state.active,
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            };

            this.props.onExitDialog(faqDto);
        }
    }

    isFormValid = (): boolean => {
        const {active} = this.state;
        const question = this.state.question.trim();
        const answer = this.state.answer.trim();
        const {editItem} = this.props;

        if (question.length > 0 && answer.length > 0 && question.length <= this.QUESTION_SIZE && answer.length <= this.ANSWER_SIZE) {
            if (editItem) {
                return editItem.question !== question || editItem.answer !== answer || editItem.active !== active;
            }
            return true;
        }
        return false;
    }

    render() {
        const {
            editItem,
            onExitDialog,
            t
        } = this.props;
        return (
            <Modal open={true}>
                <Modal.Header>
                    <div className='display--flex align-items--center justify-content--space-between'>
                        <span>
                            <Icon name='newspaper outline' size='large' />
                            {t("FAQ" + (editItem ? ":EDIT_FAQ" : ":ADD_FAQ"))}
                        </span>
                        {editItem && editItem.metadata &&
                            <div style={{fontSize: 14, color: 'grey', fontWeight: 'normal'}}>
                                {editItem.metadata.createdTimestamp &&
                                    <span className='margin-right--10px'>
                                        {t("FAQ:CREATED")}: {formatDate(editItem.metadata.createdTimestamp)}
                                    </span>
                                }
                                {editItem.metadata.changedTimestamp && editItem.metadata.changedTimestamp !== editItem.metadata.createdTimestamp &&
                                    <span>{t("FAQ:EDITED")}: {formatDate(editItem.metadata.changedTimestamp)}</span>
                                }
                            </div>
                        }
                    </div>
                </Modal.Header>
                <Modal.Content>
                    <div className='margin-bottom--10px'>
                        <label className='width--100Percent'>
                            <b>{t("FAQ:QUESTION")}</b>
                        </label>
                        <Input
                            fluid={true}
                            value={this.state.question}
                            onChange={(e, v) => this.setState({question: v.value.substring(0, this.QUESTION_SIZE)})}
                        />
                    </div>
                    <div>
                        <label className='width--100Percent'>
                            <b>{t("FAQ:ANSWER")}</b>
                        </label>
                        <TextArea
                            style={{width: "100%", height: 500, padding: 10}}
                            value={this.state.answer}
                            onChange={(e) => this.setState({answer: e.currentTarget.value.substring(0, this.ANSWER_SIZE)})}
                        />
                        <span>{this.ANSWER_SIZE - this.state.answer.length} {t("FAQ:CHAR_LEFT")}</span>
                    </div>
                    <div className='display--flex align-items--center margin-top--10px'>
                        <label className='margin-right--10px'>
                            <b>{t("FAQ:ACTIVE")}</b>
                        </label>
                        <Checkbox
                            toggle={true}
                            checked={this.state.active}
                            onChange={(e, v) => this.setState({active: !this.state.active})}
                        />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        icon={"checkmark"}
                        onClick={this.onClickCreate}
                        disabled={!this.isFormValid()}
                    />
                    <Button
                        icon={"ban"}
                        onClick={() => onExitDialog()}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default FaqCreationDialog;



// WEBPACK FOOTER //
// ./src/views/AdminView/FaqTab/FaqCreationDialog.tsx